export default __webpack_public_path__ + "static/media/icon-message copy.4d72e99b.svg";